import { TipoEmpresa } from "./types/tipoEmpresa";
import { fetchWithRetry } from "../client";

export async function fetchTipoEmpresa(): Promise<TipoEmpresa[]> {
  const res = await fetchWithRetry<{ data: TipoEmpresa[] }>(
    `/carga/empresa-tipos`,
  );
  return res.data;
}
